import styled from "styled-components";

export const ModalContainer = styled.div`
  padding: 0 40px 40px;
`;

export const ChannelResponseContainer = styled.div`
  display: flex;
  alignitems: center;
  height: 30px;
`;

export const ChannelResponseIcon = styled.span`
  display: inline-block;
  width: 30px;
`;

export const ChannelResponseContent = styled.span`
  display: inline-block;
  text-transform: capitalize;
  width: 200px;
  font-weight: 600;
`;
export const PlatformAdLink = styled.a`
  color: blue;
  text-decoration: underline;
`;
